export type FieldType = 'text' | 'select' | 'selectAll' | 'dateRange' | 'checkbox';

export interface DateRange {
  from: Date | null;
  to: Date | null;
}

export interface SelectOption {
  label: string;
  id?: string;
  value?: any;
  selected?: boolean;
  checked?: boolean;
  disabled?: boolean;
  visibleWhen?: (model: any) => boolean;
}

export interface FilterChip {
  id: string;
  text: string;
  disabled?: boolean;
}

/**
 * Chip multiplo (1 chip per valore) con id univoco.
 * Usato ad esempio per selectAll/multi-select.
 */
export interface MultiChipText {
  id: string;
  text: string;
}

/**
 * Config opzionale per gestire i chip dei filtri direttamente dal SearchPanel.
 */
export interface ChipDef<TModel> {
  /** id del chip (usato per il remove) */
  id: string;
  /** Ritorna il testo del chip (gia' tradotto o chiave translate, a scelta del chiamante) */
  textFn: (model: TModel) => string | string[] | MultiChipText[] | null | undefined;
  /** Logica di reset del campo quando si rimuove il chip */
  clear: (model: TModel) => void;
  /**
   * Se true, il chip viene mostrato anche se il campo non ha "valore" (utile per toggle/checkbox).
   * Default false.
   */
  showWhen?: (model: TModel) => boolean;
}

export interface FieldDef<TModel> {
  id: string;
  type: FieldType;
  labelKey: string;
  disabled?: boolean;

  /**
   * Solo per i campi select (ds-select-list): abilita/disabilita la searchbox interna.
   * Se undefined, il DS component usa il suo default.
   */
  hasSearchbox?: boolean;

  get: (model: TModel) => any;
  set: (model: TModel, value: any) => void;

  visibleWhen?: (model: TModel) => boolean;
  disabledWhen?: (model: TModel) => boolean;

  /** Opzioni statiche (select) */
  options?: SelectOption[];
  /** Opzioni dinamiche (select). Se presente, ha precedenza su `options`. */
  optionsFn?: (model: TModel) => SelectOption[];

  /** Se true, il campo è in caricamento (es. opzioni ancora non pronte). */
  loadingWhen?: (model: TModel) => boolean;

  /** Chip associato al campo (se vuoi far gestire chip/reset al SearchPanel) */
  chip?: ChipDef<TModel>;

  /**
   * Solo per i campi data (ds-date-picker):
   * - true  => range attivo (da/a)
   * - false => singola data
   * Default: true per retro-compatibilità.
   */
  isRangePicker?: boolean;
}

export const convertStringToDate = (value: string): Date => {
  // "dd.MM.yyyy" => Date(yyyy-MM-dd)
  const dateParts = value.split('.');
  const correctPos = [dateParts[1], dateParts[0], dateParts[2]].join('-');
  return new Date(correctPos);
};
